import { useState } from "react";
import { GroupIds } from "../../models/enumerations/group-ids";
import CorrectiveProgramsService from "../../utilities/services/corrective-programs-service/corrective-programs-serivce";
import { Button } from "../../components/button/button";

const COMPONENT_CLASS = "c-determine-corrective-program-tool";

const DetermineCorrectiveProgramTool: React.FC = () => {
    const options = [
        GroupIds.TOE_TOUCH,
        GroupIds.SQUAT,
        GroupIds.BALANCE,
        GroupIds.ROTATION,
        GroupIds.SHOULDER_MOBILITY,
        GroupIds.SHOULDER_CLEARING,
        GroupIds.SPINE_CLEARING,
        GroupIds.TOE_TOUCH_BREATHING,
        GroupIds.SQUAT_BREATHING,
        GroupIds.BALANCE_BREATHING,
        GroupIds.ROTATION_BREATHING,
        GroupIds.SHOULDER_MOBILITY_BREATHING,
        GroupIds.SHOULDER_CLEARING_BREATHING,
        GroupIds.SPINE_CLEARING_BREATHING,
    ];

    const [selectedFocusArea, setSelectedFocusArea] = useState<string>("");
    const [percentage, setPercentage] = useState<number | undefined>();
    const [score, setScore] = useState<number | undefined>();
    const [foundProgram, setFoundProgram] = useState<string>("");

    const calculate = async () => {
        if (!selectedFocusArea || percentage == null || score == null) {
            return;
        }

        // 🔑 Rule: score 0 forces percentage 0
        const normalizedPercentage = score === 0 ? 0 : percentage;

        const focusArea = {
            groupId: selectedFocusArea,
            percentage: normalizedPercentage,
            score,
        };

        const result = await CorrectiveProgramsService.findProgram({
            focusArea,
        });


        setFoundProgram(result.programId);
    };


    return (
        <div className={COMPONENT_CLASS}>
            <form>

                <div className={`${COMPONENT_CLASS}__field`}>
                    <label>Movement Focus Area</label>
                    <select
                        value={selectedFocusArea}
                        onChange={(e) => setSelectedFocusArea(e.target.value)}
                    >
                        <option value="">Select Movement Focus Area</option>
                        {options.map(option => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>

                <div className={`${COMPONENT_CLASS}__field`}>
                    <label>Percentage</label>
                    <input
                        type="number"
                        min={0}
                        max={100}
                        value={percentage ?? ""}
                        onChange={(e) => {
                            const value = Number(e.target.value);
                            if (value >= 0 && value <= 100) {
                                setPercentage(value);
                            }
                        }}
                    />
                </div>

                <div className={`${COMPONENT_CLASS}__field`}>
                    <label>Score</label>
                    <input
                        type="number"
                        min={0}
                        max={3}
                        step={1}
                        value={score ?? ""}
                        onChange={(e) => {
                            const value = Number(e.target.value);
                            if (value >= 0 && value <= 3) {
                                setScore(value);
                            }
                        }}
                    />
                </div>
            </form>
            <Button buttonText="Find Program" onClick={calculate} />

            {foundProgram && (
                <div className={`${COMPONENT_CLASS}__result`}>
                    <h3>Found Program:</h3>
                    <p>{foundProgram}</p>
                </div>
            )}

        </div>
    );

};

export default DetermineCorrectiveProgramTool;
